import Cookies from 'js-cookie'

const TOKEN_KEY = 'TOKEN'
const TOKEN_KEY_PEDIGREE = 'PEDIGREE_TOKEN'

export function getToken() {
  const token = Cookies.get(TOKEN_KEY)
  return token ? token === 'undefined' ? '' : token : ''
}

export function setToken(token) {
  return Cookies.set(TOKEN_KEY, token)
}

export function removeToken() {
  return Cookies.remove(TOKEN_KEY)
}

export function getTokenPedigree() {
  const token = localStorage.getItem(TOKEN_KEY_PEDIGREE)
  return token ? token === 'undefined' ? '' : token : ''
}

export function setTokenPedigree(token) {
  return localStorage.setItem(TOKEN_KEY_PEDIGREE, token)
}

export function removeTokenPedigree() {
  return localStorage.removeItem(TOKEN_KEY_PEDIGREE)
}
